import type {IdentityVerificationSchema} from '../identityVerification';

export const getDocumentNationality = (state: IdentityVerificationSchema) =>
  state.setupFormDate.nationality;
